import { createDealFormDataAdapter } from '@crm/features/add-new-deal/lib';
import { apiInstance } from '@crm/shared/api';

import { addNewDealApiRoutes } from './api-routes';

import type {
    TCreateDealPayload,
    TCreateDealResponse,
} from '@crm/features/add-new-deal/model/form.schema';

export const createDeal = (data: TCreateDealPayload, defaultDealName: string) =>
    apiInstance
        .post(addNewDealApiRoutes.createDealRoute(), {
            body: createDealFormDataAdapter(data, defaultDealName),
        })
        .json<TCreateDealResponse>();

export const createDealMutationOptions = (defaultDealName: string) => ({
    mutationKey: ['deals', 'create'],
    mutationFn: (data: TCreateDealPayload) => createDeal(data, defaultDealName),
});
